import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {XrefAddRecipientModalComponent} from "./components/xref-add-recipient-modal/xref-add-recipient-modal.component";
import {XrefAddPulseRecipientModalComponent} from "./components/xref-add-pulse-recipient-modal/xref-add-pulse-recipient-modal.component";
import {XrefBulkUploadModalComponent} from "./components/xref-bulk-upload-modal/xref-bulk-upload-modal.component";
import {AlertMessageModule} from "../../lib/alert-message/alert-message.module";
import {FormsModule} from "@angular/forms";
import {SendXrefComponent} from "./send-xref.component";
import {BulkUploadComponent} from './components/bulk-upload/bulk-upload.component';
import {FileUploadModule} from 'ng2-file-upload';
import {
  RecipientsDetailsTableComponent
} from './components/recipients-details-table/recipients-details-table.component';
import {
  SelectQuestionnaireModalComponent
} from './components/select-questionnaire-modal/select-questionnaire-modal.component';
import {EmailAndSmsComponent} from './components/email-and-sms/email-and-sms.component';
import {AvatarIconComponent} from './components/avatar-icon/avatar-icon.component';
import {AlertModule} from 'ngx-bootstrap/alert';
import {EditRecipientComponent} from './components/edit-recipient/edit-recipient.component';
import {CharacterLimitModule} from "../character-limit/character-limit.module";
import {SortModule} from "../sort/sort.module";
import {SearchModule} from "../search/search.module";
import {AppPaginationModule} from "../pagination/pagination.module";
import {InformationModalComponent} from './components/information-modal/information-modal.component';
import {PhoneInputModule} from "../../lib/phone-input/phone-input.module";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {TooltipEllipsifyModule} from 'src/app/directives/tooltip-ellipsify/tooltip-ellipsify.module';
import {EmailRegexValidatorModule} from "../../lib/email-regex-validator/email-regex-validator.module";
import {LoaderModule} from "src/app/components/loader/loader.module";
import {BsDropdownModule} from "ngx-bootstrap/dropdown";
import {SendRequestActionsModule} from '../send-request-actions/send-request-actions.module';
import {RequestSettingsComponent} from './components/request-settings/request-settings.component';
import {ListRecipientsModalComponent} from './components/list-recipients-modal/list-recipients-modal.component';
import {SingleRecipientComponent} from './components/single-recipient/single-recipient.component';
import {
  SingleReferenceRecipientComponent
} from './components/single-reference-recipient/single-reference-recipient.component';
import {
  EditReferenceRecipientComponent
} from './components/edit-reference-recipient/edit-reference-recipient.component';
import {
  XrefAddReferenceRecipientModalComponent
} from './components/xref-add-reference-recipient-modal/xref-add-reference-recipient-modal.component';
import {ReferenceBulkUploadComponent} from './components/reference-bulk-upload/reference-bulk-upload.component';
import { ReactiveFormsModule } from '@angular/forms';
import { EditPulseRecipientComponent } from './components/edit-pulse-recipient/edit-pulse-recipient.component';
import {
    BannerModule,
    ButtonModule,
    CheckboxModule,
    DropdownModule, GroupDropdownModule, InputsModule,
    MultiSelectModule,
    RadioModule,
    TagsModule,
    CardsModule,
    AvatarModule,
    TooltipModule as xrefTooltipModule,
    DynamicGroupDropdownModule,
    ProductToggleModule, EmptyStateSearchModule, EmptyStateModule,
    LozengeModule, SubmitSearchModule, SearchResultModule

} from '@xref/xref-lib';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { XrefCutOffScheduleDatePickerModalComponent } from './components/xref-cut-off-schedule-date-picker-modal/xref-cut-off-schedule-date-picker-modal.component';
import { SelectedQuestionnaireModule } from './components/selected-questionnaire/selected-questionnaire.module';
import { QuestionnaireListModule } from './components/questionnaire-list/questionnaire-list.module';
import { DateConversionPipeModule } from "src/app/pipes/date-conversion-pipe/date-conversion.module";
import { DynamicDateConversionPipeModule } from 'src/app/pipes/dynamic-date-conversion-pipe/dynamic-date-conversion.module';
import { EditBackgroundRecipientComponent } from './components/edit-background-recipient/edit-background-recipient.component';
import { AddBackgroundCheckModalComponent } from './components/add-background-check-modal/add-background-check-modal.component';
import { SingleBackgroundCheckRecipientComponent } from './components/single-background-check-recipient/single-background-check-recipient.component';
import { AddRecipientBackgroundCheckModalComponent } from './components/add-recipient-background-check-modal/add-recipient-background-check-modal.component';
import { SelectBackgroundCheckModalComponent } from './components/select-background-check-modal/select-background-check-modal.component';
import { SelectTemplateModalComponent } from './components/select-template-modal/select-template-modal.component';
import { SortV2Module } from '../sort-v2/sort-v2.module';
import { BackgroundCheckListComponent } from './components/background-check-list/background-check-list.component';
import { BackgroundCheckFilterModalComponent } from '../background-check-filter-modal/background-check-filter-modal.component';
import { NgSelectModule } from "@ng-select/ng-select";
import { SelectedBackgroundCheckComponent } from './components/selected-background-check/selected-background-check.component';
import { LockedFeatureModalModule } from '../locked-feature-modal/locked-feature-modal.module';
import { SmsConsentCheckboxComponent } from './components/sms-consent-checkbox/sms-consent-checkbox.component';

@NgModule({
  declarations: [
    SendXrefComponent,
    XrefAddRecipientModalComponent,
    XrefAddPulseRecipientModalComponent,
    XrefBulkUploadModalComponent,
    BulkUploadComponent,
    RecipientsDetailsTableComponent,
    SelectQuestionnaireModalComponent,
    EmailAndSmsComponent,
    AvatarIconComponent,
    EditRecipientComponent,
    EditPulseRecipientComponent,
    InformationModalComponent,
    RequestSettingsComponent,
    ListRecipientsModalComponent,
    SingleRecipientComponent,
    SingleReferenceRecipientComponent,
    EditReferenceRecipientComponent,
    XrefAddReferenceRecipientModalComponent,
    ReferenceBulkUploadComponent,
    EditPulseRecipientComponent,
    XrefCutOffScheduleDatePickerModalComponent,
    EditBackgroundRecipientComponent,
    AddBackgroundCheckModalComponent,
    SingleBackgroundCheckRecipientComponent,
    AddRecipientBackgroundCheckModalComponent,
    SelectBackgroundCheckModalComponent,
    SelectTemplateModalComponent,
    BackgroundCheckListComponent,
    BackgroundCheckFilterModalComponent,
    SelectedBackgroundCheckComponent,
    SmsConsentCheckboxComponent
  ],
  imports: [
    CommonModule,
    AlertMessageModule,
    FormsModule,
    FileUploadModule,
    AlertModule,
    CharacterLimitModule,
    SortModule,
    SearchModule,
    AppPaginationModule,
    PhoneInputModule,
    EmailRegexValidatorModule,
    TooltipModule.forRoot(),
    TooltipEllipsifyModule,
    BsDropdownModule.forRoot(),
    LoaderModule,
    SendRequestActionsModule,
    ReactiveFormsModule,
    BannerModule,
    ButtonModule,
    TagsModule,
    AccordionModule,
    BsDatepickerModule,
    SelectedQuestionnaireModule,
    QuestionnaireListModule,
    DropdownModule,
    DateConversionPipeModule,
    DynamicDateConversionPipeModule,
    InputsModule,
    SortV2Module,
    RadioModule,
    PopoverModule,
    NgSelectModule,
    CheckboxModule,
    MultiSelectModule,
    xrefTooltipModule,
    GroupDropdownModule,
    DynamicGroupDropdownModule,
    CardsModule,
    AvatarModule,
    ProductToggleModule,
    EmptyStateSearchModule,
    EmptyStateModule,
    LozengeModule,
    SubmitSearchModule,
    SearchResultModule,
    LockedFeatureModalModule
  ],
  exports: [
    SendXrefComponent,
    SelectedBackgroundCheckComponent,
    RequestSettingsComponent
  ]
})
export class SendXrefModule {
}
